import { Link } from '@tanstack/react-router';
import { ReadOnlyValue } from '@/shared/components';
import { I } from '@/shared/icons';
import { formatRelative } from '@/shared/lib/format';
import type { LastBookingPerOtaItem } from '@/shared/api';

interface LastBookingCellProps {
  lastBooking: LastBookingPerOtaItem | null;
}

export function LastBookingCell({ lastBooking }: LastBookingCellProps) {
  if (!lastBooking) {
    return (
      <ReadOnlyValue
        label="Letzte Buchung"
        value="noch keine"
        hint="Über dieses Portal ist noch keine Buchung eingetroffen."
      />
    );
  }
  const relative = formatRelative(lastBooking.receivedAt);
  const detail = lastBooking.guestName ?? lastBooking.channexBookingId.slice(0, 8);
  // Click-Through nur wenn Domain-Booking existiert.
  const valueNode = lastBooking.domainBookingId ? (
    <Link
      to="/bookings/$id"
      params={{ id: lastBooking.domainBookingId }}
      className="text-ink hover:text-sage inline-flex min-h-11 items-center gap-1.5 transition-colors"
      aria-label={`Buchung von ${detail} öffnen`}
    >
      <span>{relative}</span>
      <I name="ExternalLink" size={10} aria-hidden />
    </Link>
  ) : (
    <span>{relative}</span>
  );
  return (
    <ReadOnlyValue
      label="Letzte Buchung"
      value={valueNode}
      hint={`${detail} · ${new Date(lastBooking.receivedAt).toLocaleString('de-DE')}`}
    />
  );
}
